// Single source of truth for navigation, social, and entity data.
// Used in nav, footer, sitemap, and JSON-LD schema.

export const SITE = {
  name: "Arif Khan",
  tagline: "Security Infrastructure & Building Technology Strategist",
  role: "Security Infrastructure & Building Technology Strategist",
  description:
    "Arif Khan is a Security Infrastructure & Building Technology Strategist with 23+ years of experience across Security Infrastructure, Perimeter Protection, Smart Automation, Audio Video and Luxury Home Cinema solutions.",
  organization: "Altima Global",
  location: "Based in New Delhi. Supporting projects across Delhi NCR, Mumbai, Lucknow, Bengaluru and North India.",
  email: "arif@arifkhanglobal.com",
  // Used for tel: link, WhatsApp, and header/footer display.
  phone: "+91 98189 28760",
  phoneE164: "+919818928760",
  whatsappNumber: "919818928760",
  url: "https://arifkhanglobal.com",
  address: {
    line1: "Altima Global, 4th Floor, Statesman House Building",
    line2: "Barakhamba Road, Connaught Place",
    city: "New Delhi",
    postalCode: "110001",
    country: "India",
    full: "Altima Global, 4th Floor, Statesman House Building, Barakhamba Road, Connaught Place, New Delhi – 110001",
  },
};

export const SERVICE_AREAS = [
  "Delhi NCR",
  "Noida",
  "Gurugram",
  "Mumbai",
  "Bengaluru",
  "Lucknow",
  "Pan India",
] as const;

export const SOCIAL = {
  linkedin: "https://www.linkedin.com/in/arifkhan-altimaglobal",
  instagram: "https://www.instagram.com/arifkhan_altima",
  twitter: "https://www.twitter.com/arifkhan_altima",
  youtube: "https://www.youtube.com/@arifkhanglobal",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/solutions", label: "Solutions" },
  { to: "/industries", label: "Industries" },
  { to: "/projects", label: "Projects" },
  { to: "/ask-arif", label: "Ask Arif" },
  {
    to: "/insights",
    label: "Insights",
    children: [
      { to: "/resources", label: "Resources & Benchmarks" },
      { to: "/insights/learning-centre", label: "Learning Centre" },
      { to: "/insights/articles-guides", label: "Articles & Guides" },
      { to: "/blog", label: "Blog" },
      { to: "/insights/media", label: "Media" },
      { to: "/insights/partners", label: "Partners" },
    ],
  },
  { to: "/for-architects", label: "For Architects" },
  { to: "/contact", label: "Contact" },
] as const;


import solSecurity from "@/assets/sol-security.jpg";
import solPerimeter from "@/assets/sol-perimeter.jpg";
import solAutomation from "@/assets/sol-automation.jpg";
import solCinema from "@/assets/sol-cinema.jpg";
import solAuditorium from "@/assets/sol-auditorium.jpg";
import solEnterprise from "@/assets/sol-enterprise.jpg";
import solCctv from "@/assets/sol-cctv.jpg";
import solAccess from "@/assets/sol-access.jpg";
import solFire from "@/assets/sol-fire.jpg";
import solGate from "@/assets/sol-gate.jpg";
import indResidences from "@/assets/ind-residences.jpg";
import indCorporate from "@/assets/ind-corporate.jpg";
import indHospitality from "@/assets/ind-hospitality.jpg";
import indEducation from "@/assets/ind-education.jpg";
import indGovernment from "@/assets/ind-government.jpg";
import indIndustrial from "@/assets/ind-industrial.jpg";
import indWarehouse from "@/assets/ind-warehouse.jpg";

export const SOLUTIONS = [
  { slug: "security-infrastructure", title: "Security Infrastructure", short: "Enterprise-grade hardening for mission-critical assets.", image: solSecurity },
  { slug: "cctv-command-centre", title: "CCTV & Command Centre", short: "Edge-AI surveillance unified under one operator console.", image: solCctv },
  { slug: "access-control-biometrics", title: "Access Control & Biometrics", short: "Facial, fingerprint and card access governed by one policy.", image: solAccess },
  { slug: "fire-alarm-life-safety", title: "Fire Alarm & Life Safety", short: "Addressable detection, evacuation and code-compliant safety.", image: solFire },
  { slug: "entrance-gate-parking-automation", title: "Entrance, Gate & Parking Automation", short: "Boom barriers, sliding gates, ANPR and visitor management.", image: solGate },
  { slug: "perimeter-protection", title: "Perimeter Protection", short: "Multi-layer detection across kilometers of perimeter.", image: solPerimeter },
  { slug: "smart-automation", title: "Smart Automation", short: "Unified intelligence for buildings that respond to people.", image: solAutomation },
  { slug: "luxury-home-cinema", title: "Luxury Home Cinema", short: "Reference-grade private theatres, acoustically engineered.", image: solCinema },
  { slug: "auditorium-av", title: "Auditorium AV", short: "Flagship audiovisual systems for institutions and stages.", image: solAuditorium },
  { slug: "enterprise-av", title: "Enterprise AV Solutions", short: "Boardrooms, training rooms, control centres at scale.", image: solEnterprise },
] as const;

export const INDUSTRIES = [
  { slug: "luxury-residences", title: "Luxury Residences & Villas", icon: indResidences },
  { slug: "farmhouses-private-estates", title: "Farmhouses & Private Estates", icon: indResidences },
  { slug: "developers-real-estate", title: "Developers & Real Estate Projects", icon: indCorporate },
  { slug: "corporate-offices", title: "Corporate & Offices", icon: indCorporate },
  { slug: "hospitality", title: "Hospitality", icon: indHospitality },
  { slug: "education-auditoriums", title: "Education & Auditoriums", icon: indEducation },
  { slug: "government-infrastructure", title: "Government & Infrastructure", icon: indGovernment },
  { slug: "industrial-facilities", title: "Industrial Facilities", icon: indIndustrial },
  { slug: "warehouses-logistics", title: "Warehouses & Logistics", icon: indWarehouse },
] as const;

export const STATS = [
  { value: "23+", label: "Years of Experience" },
  { value: "1000+", label: "Projects Delivered" },
  { value: "500km+", label: "Perimeter Secured" },
] as const;

// Canonical WhatsApp deep link (prefilled intro message).
export const WHATSAPP_HREF = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
  "Hi Arif, I found you on arifkhanglobal.com and would like to discuss a project.",
)}`;
